import { createSlice } from "@reduxjs/toolkit";

interface SettingSlice {
  lang: any;
  theme: string;
}

const initialState: SettingSlice = {
  lang: localStorage.getItem("lang"),
  theme: localStorage.getItem("theme") || "light",
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.lang = action.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
  },
});

export const { setLanguage, setTheme } = settingSlice.actions;

const settingReducer = settingSlice.reducer;
export default settingReducer;

